var map = {
	"./_settings.scss": 1391,
	"./base/_alert-boxes.scss": 1392,
	"./base/_badges.scss": 1393,
	"./base/_base.scss": 1394,
	"./base/_cw-footer.scss": 1395,
	"./base/_fonts.scss": 1396,
	"./base/_forms.scss": 1397,
	"./base/_grid.scss": 1398,
	"./base/_layout.scss": 1399,
	"./base/_lightbox.scss": 1400,
	"./base/_modal.scss": 1401,
	"./base/_nav-bar.scss": 1402,
	"./base/_normal_font.scss": 117,
	"./base/_offcanvas.scss": 1403,
	"./base/_pagination.scss": 1404,
	"./base/_panels.scss": 1405,
	"./base/_sharing.scss": 1406,
	"./base/_switches.scss": 1407,
	"./base/_tables.scss": 1408,
	"./base/_tooltips.scss": 1409,
	"./base/_type.scss": 1410,
	"./base/_video.scss": 1411,
	"./base/_visibility.scss": 1412,
	"./base/buttons/_all.scss": 1413,
	"./base/buttons/_mixins.scss": 1414,
	"./base/buttons/_sharing.scss": 1415,
	"./base/forms/_checkboxes.scss": 1416,
	"./base/forms/_input-combos.scss": 1417,
	"./base/forms/_non-text.scss": 1418,
	"./base/forms/_text-fields.scss": 1419,
	"./base/nav-bar/_base-with-links.scss": 1420,
	"./base/nav-bar/_base.scss": 1421,
	"./base/nav-bar/_fade.scss": 1422,
	"./base/nav-bar/_inverted.scss": 1423,
	"./base/nav-bar/_large-up.scss": 1424,
	"./components/cards/_cards.scss": 1425,
	"./components/hero/_hero.scss": 1426,
	"./components/hero/_image_hero.scss": 1427,
	"./components/info/_pillars.scss": 1428,
	"./components/info/_stats.scss": 1429,
	"./components/media-blocks/_content-media-block-left.scss": 1430,
	"./components/story-selector/_story-selector.scss": 1431,
	"./pages/accounts.scss": 1432,
	"./pages/admin.scss": 1433,
	"./pages/admin/grants.scss": 1434,
	"./pages/admin/offline_donations.scss": 1435,
	"./pages/asset_generator.scss": 1436,
	"./pages/authorization.scss": 1437,
	"./pages/birthdays.scss": 1438,
	"./pages/campaigns.scss": 1439,
	"./pages/donations.scss": 1440,
	"./pages/donations/_donate-form.scss": 1441,
	"./pages/donations/_hidden-campaign.scss": 1442,
	"./pages/donations/_sponsor-recognition.scss": 1443,
	"./pages/donations/_thank-you.scss": 1444,
	"./pages/donations/components/_ach-popout-form.scss": 1445,
	"./pages/donations/components/_apple-pay-button.scss": 1446,
	"./pages/donations/components/_browser-fallback.scss": 1447,
	"./pages/donations/components/_donate-buttons.scss": 1448,
	"./pages/donations/components/_donate-by-check-modal.scss": 1449,
	"./pages/donations/components/_donation-form-inputs.scss": 1450,
	"./pages/donations/components/_gift_aid.scss": 1451,
	"./pages/donations/components/_iho.scss": 1452,
	"./pages/donations/components/_offscreen-donate-components.scss": 1453,
	"./pages/donations/components/_stripe-elements.scss": 1454,
	"./pages/donations/dynamic.scss": 1455,
	"./pages/donations/gift-the-spring.scss": 1456,
	"./pages/donations/the-spring-new.scss": 1457,
	"./pages/donations/thespring.scss": 1458,
	"./pages/edit_mailing_list_subscriber.scss": 1459,
	"./pages/exceptions.scss": 1460,
	"./pages/founders.scss": 1461,
	"./pages/mailing-list-subscribers.scss": 1462,
	"./pages/partners.scss": 1463,
	"./pages/premium_impact_profile.scss": 1464,
	"./pages/profile/bps_membership.scss": 1465,
	"./pages/profile/lifetime_impact.scss": 1466,
	"./pages/profile/my_projects.scss": 1467,
	"./pages/profile/shared.scss": 1468,
	"./pages/profile/spring_membership.scss": 1469,
	"./pages/profile/user_private.scss": 1470,
	"./pages/profile/user_public.scss": 1471,
	"./pages/projects/_country_icons.scss": 1472,
	"./pages/projects/projects.scss": 1473,
	"./pages/redeem-the-spring.scss": 1474,
	"./pages/search.scss": 1475,
	"./pages/september-campaign/_modal.scss": 1476,
	"./pages/september_2020.scss": 1477,
	"./pages/static_pages/about.scss": 1478,
	"./pages/static_pages/brand_partnerships.scss": 1479,
	"./pages/static_pages/company_match.scss": 1480,
	"./pages/static_pages/company_match_iframe.scss": 1481,
	"./pages/static_pages/completed_projects.scss": 1482,
	"./pages/static_pages/css_docs.scss": 1483,
	"./pages/static_pages/education.scss": 1484,
	"./pages/static_pages/error.scss": 1485,
	"./pages/static_pages/financials.scss": 1486,
	"./pages/static_pages/fundraise.scss": 1487,
	"./pages/static_pages/gala_dashboard.scss": 1488,
	"./pages/static_pages/home.scss": 1489,
	"./pages/static_pages/hundred_percent_model.scss": 1490,
	"./pages/static_pages/in_kind_donations.scss": 1491,
	"./pages/static_pages/internships.scss": 1492,
	"./pages/static_pages/jobs.scss": 1493,
	"./pages/static_pages/kids.scss": 1494,
	"./pages/static_pages/local_partners.scss": 1495,
	"./pages/static_pages/media.scss": 1496,
	"./pages/static_pages/mission.scss": 1497,
	"./pages/static_pages/our_approach.scss": 1498,
	"./pages/static_pages/our_projects.scss": 1499,
	"./pages/static_pages/our_work.scss": 1500,
	"./pages/static_pages/privacy.scss": 1501,
	"./pages/static_pages/scott_harrison_story.scss": 1502,
	"./pages/static_pages/scotts_story.scss": 1503,
	"./pages/static_pages/sensors.scss": 1504,
	"./pages/static_pages/staff.scss": 1505,
	"./pages/static_pages/the_pool.scss": 1506,
	"./pages/static_pages/volunteer.scss": 1507,
	"./pages/static_pages/water_crisis_learn.scss": 1508,
	"./pages/static_pages/whywater.scss": 1509,
	"./pages/stories.scss": 1510,
	"./pages/subscriptions.scss": 1511,
	"./pages/teams.scss": 1512,
	"./pages/the_spring_series.scss": 1513,
	"./pages/thirst/thirst.scss": 1514,
	"./pages/uk/about.scss": 1515,
	"./pages/uk/partnerships.scss": 1516,
	"./pages/uk/privacy.scss": 1517,
	"./pages/uk/uk.scss": 1518,
	"./pages/unpledge.scss": 1519,
	"./pages/video_landing_page.scss": 1520,
	"./pages/wwd/community.scss": 1521,
	"./pages/wwd/discover.scss": 1522,
	"./pages/wwd/explore.scss": 1523,
	"./pages/wwd/profile.scss": 1524,
	"./pages/wwd/shared.scss": 1525,
	"./pages/wwd/welcome.scss": 1526,
	"./patterns/action-tiles.scss": 1527,
	"./patterns/avatar-initial.scss": 1528,
	"./patterns/clamp-for-ellipsis.scss": 1529,
	"./patterns/cw-icon-spin.scss": 1530,
	"./patterns/dashed-elements.scss": 1531,
	"./patterns/full-bottom-bg.scss": 1532,
	"./patterns/image-fill.scss": 1533,
	"./patterns/latest-update-indicator.scss": 1534,
	"./patterns/leading-image-block.scss": 1535,
	"./patterns/module.scss": 1536,
	"./patterns/progress.scss": 1537,
	"./patterns/side-by-side.scss": 1538,
	"./patterns/split-bg-block.scss": 1539,
	"./patterns/tabs.scss": 1540,
	"./patterns/text-separator.scss": 1541,
	"./patterns/yellow-underlined.scss": 1542,
	"./react-components/completed-projects-map.scss": 1543,
	"./react-components/email-capture-modal.scss": 1544,
	"./react-components/journey-player.scss": 1545,
	"./react-components/mailing-list-intercept-modal.scss": 1546,
	"./react-components/people-served-input.scss": 1547,
	"./settings/_colors.scss": 1548,
	"./settings/_general.scss": 1549,
	"./settings/_media-queries.scss": 1550,
	"./settings/_mixins.scss": 1551,
	"./settings/_type.scss": 1552,
	"./shared/breadcrumbs.scss": 1553,
	"./shared/clipboard-button.scss": 1554,
	"./shared/comments.scss": 1555,
	"./shared/cookie_banner.scss": 1556,
	"./shared/datepicker.scss": 1557,
	"./shared/fixed-banner.scss": 1558,
	"./shared/geosuggest.scss": 1559,
	"./shared/grecaptcha.scss": 1560,
	"./shared/hide-donate-links.scss": 1561,
	"./shared/intl-tel-input.scss": 1562,
	"./shared/mailing-list-form.scss": 1563,
	"./shared/mailing-list-sign-up-button.scss": 1564,
	"./shared/mobile-donate-banner.scss": 1565,
	"./shared/parsley.scss": 1566,
	"./shared/percy.scss": 1567,
	"./shared/public_campaign_card_details.scss": 1568,
	"./shared/simple-form.scss": 1569,
	"./shared/sly-quiz.scss": 1570,
	"./shared/spring_logo_svg.scss": 1571,
	"./shared/spring_mark_svg.scss": 1572,
	"./shared/spring_series_seasons.scss": 1573,
	"./shared/video-box-container.scss": 1574,
	"./tailwinds.scss": 251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1390;